<template>

    <div v-if="matches.length > 0" class="SC-split__col player-score__live">

        <div class="caption">Live match</div>

        <div class="Results-matches">

            <score-card v-for="match in matches"
                        :match="match"
                        :flagPath="flagPath"
                        :key="match.id"
                        :detail="detail"
                        mode="live"
                        :data-id="match.id">
            </score-card>

        </div>

    </div>

</template>

<script>
    import axios from 'axios'
    import MatchCard from './MatchCard.vue'

    export default {
        props: ['player', 'type', 'flag', 'detail'],
        components: {
            'score-card': MatchCard,
        },
        data() {
            return {
                feed: [],
                flagPath: this.flag + '/assets/dist/svg/flags/',
                matches: []
            }
        },
        created: function () {

            this.getLive()

            let app = this
            setInterval(function () {
                app.getLive()
            }, 15 * 1000, app)

        },
        methods: {
            determineFeedUrl() {

                if (this.type == 'atp') {
                    return window.atp_ip
                } else {
                    return window.wta_ip
                }

            },
            removeFinishedMatches(matches) {

                return matches.filter(function (match) {

                    return match.detail.state != 'F'

                })

            },
            getOnlyPlayerMatches(matches) {

                return matches.filter(function (match) {

                    if (match.detail.idA == this || match.detail.idA2 == this || match.detail.idB == this || match.detail.idB2 == this) {
                        return match
                    }

                }, this.player)

            },
            getLive() {

                let ip = this.determineFeedUrl()

                axios.get(`${ip}/get/${this.type}/live`).then(response => {

                    this.feed = response.data

                    let liveMatches = this.removeFinishedMatches(response.data)
                    let playerMatches = this.getOnlyPlayerMatches(liveMatches)

                    this.matches = playerMatches

                }).catch(function (error) {
                    console.log(error);
                });

            }
        }
    }
</script>